import { ChaordicService } from './chaordic.service'

export class AdicionarItemCestaObserver {
    constructor() {
        this.service = new ChaordicService();
    }

    next(response) {
        //carrinho
        if(response.data) {
            const cart = this.service.buildCarrinho(response.data);
            /* const page = this.service.buildPage(); */

            //push event
            chaordic.push(['updateCart', cart]);

            //update chaordic_meta
            /* window.chaordic_meta.cart = cart;
            window.chaordic_meta.page = page; */
        }
    }

    error(error) {}

    complete() {}
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/chaordic/adicionarItemCesta.observer.js